import { Encumbrance } from 'types';

type IsActiveEncumbranceProps = {
  encumbrance: Encumbrance;
};

export const isActiveEncumbrance = ({
  encumbrance,
}: IsActiveEncumbranceProps): boolean => {
  if (!encumbrance.endDate) {
    return true;
  }
  const today = new Date();
  const endDate = new Date(encumbrance.endDate);

  return endDate >= today;
};
